import { RowClassParams } from 'ag-grid-community';

export const TRANS_OVA_GENETICS_COMPANY_ID =
  '10000000-0000-0000-0000-000000000001';
export const NO_EMBRYOS_PRODUCED_VALUE = 'NO_EMBRYOS_PRODUCED';
export const CONTAMINANT_PRESENT_VALUE = 'CONTAMINANT_PRESENT';

export const RECOVERY_CODES_BY_COMPANY = {
  TOG: 'E608',
  EVOLYGEN: 'E1790',
  ALTA_BR: '1182-7',
  CRANDALL: 'E608',
};
export const SLAUGHTER_HOUSE_SITES = ['CRIA', 'CRTX', 'CRWA', 'CRTXP'];
export const FREEZE_DAY_OPTIONS = [
  { label: '6.5', value: 6.5 },
  { label: '7', value: 7 },
];

export const FIELD_NAMES = {
  NO_EMBRYOS_PRODUCED: 'noEmbryosProduced',
  CONTAMINANT_PRESENT: 'contaminantPresent',
  STAGE: 'stage',
  GRADE: 'grade',
  D65: 'd65',
  D7: 'd7',
  FREEZE_TIME: 'freezeTime',
  GRADER_65_NAME: 'grader65Name',
  GRADER_65_ID: 'grader65Id',
  GRADER_7_NAME: 'grader7Name',
  GRADER_7_ID: 'grader7Id',
  FREEZE_TECH_ID: 'freezeTechId',
  FREEZE_TECH_NAME: 'freezeTechName',
  LG: 'lowQuality',
  OWNER_ID: 'ownerId',
  PLATE: 'plateNumber',
  PREDICTION_TECH: 'predictedById',
  TT: 'tt',
  DC: 'discard',
  CLEAVED: 'cleaved',
  QUALITY: 'predictedGood',
  LOW: 'predictedVeryLow',
  HELD_FREEZE: 'heldAtTogToFreeze',
};

export const hardcodedSites = [
  { label: 'MO - Missouri', value: '2' },
  { label: 'Main Farm', value: '1' },
  { label: 'MO - D5', value: '3' },
  { label: 'TOGU', value: '4' },
  { label: 'MAC to Main Farm', value: '6' },
  { label: 'MAC to TXP', value: '8' },
  { label: 'Incoming to WAC', value: '9' },
  { label: 'TXP to TX', value: '10' },
  { label: 'CRTXP to CA', value: '11' },
];

export const defaultGradingRows = [
  {
    grade: 1,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
  {
    grade: 2,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
  {
    grade: 3,
    s4: null,
    s5: null,
    s6: null,
    s7: null,
    s8: null,
    s9: null,
    total: 0,
  },
];

export const rowClassRules = {
  'fresh-shipment-form__row-shaded': (params: RowClassParams) =>
    params.rowIndex % 2 === 1,
};

// Site UUIDs now live in @/utils/freezeSites so Freeze and Freeze V2 share
// one mapping table. Re-exported here to keep existing imports working.
export {
  INCOMING_TO_WAC_ID,
  MAC_TO_MAIN_FARM_ID,
  MAIN_FARM_ID,
  MO_MISSOURI_ID,
  TXP_TO_TX_ID,
} from '@/utils/freezeSites';
export const TX_ID = '8c229164-4c97-de11-8de3-0019d18a6560';

export const GRADE_1 = 1;
export const GRADE_2 = 2;
export const DAY_6_5_FLAG = 1;
export const DAY_7_FLAG = 1;
export const GRADE_2_SUFFIX = 'X';

export const GRADE_1_LABEL = 'G1:';
export const GRADE_2_LABEL = 'G2:';
export const TOTALS_LABEL = 'Totals:';

export const INITIAL_COUNT = 0;
export const INITIAL_CANE_COUNT = 1;

export const EMBRYOS_PER_STRAW_VALUE = 1;
export const EMBRYOS_PER_VIT_STRAW_VALUE = 5;
